<template>
	<div>
		<!-- This UI can be simplified as most logic moves to Vuex -->
		<div class="mt-4 pt-4 text-center">
			<div class="row">
				<div class="col-md-4 col-xs-6 verify-page">
					<div class="card pb-3">
						<div class="card-body text-center">
							<div>
								<img src="@/assets/img/logo.png" class="w-100">
							</div>
							<div v-if="isError">
								<div class="text-danger">
									<h3>Access Denied!</h3>
									<p>You do not have access to this page. Please <a :href="this.$auth_ui + 'user-settings/'">Log in</a> as a different user.</p>
								</div>
							</div>
							<div v-else>
								<div class="spinner-border text-info" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
								<p class="text-muted">verifying access..</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            isError: false,
        }
    },
    computed: {
        ...mapState('auth', ['accessToken']),
    },
    async mounted() {
        try {
            // Prioritize token from URL query
            const tokenFromUrl = this.$route.query.access_token;
            const tokenToVerify = tokenFromUrl || this.accessToken;

            if (!tokenToVerify) {
                // If no token anywhere, dispatch logout action
                this.logout('Please log in.');
                return;
            }

            // Dispatch a new action to handle verification
            const { success, type, org } = await this.verifyAuthentication(tokenToVerify);

            if (success) {
                const returnPath = localStorage.getItem("return");
                if (returnPath) {
                    localStorage.removeItem("return"); // Clean up
                    this.$router.push({ path: returnPath });
                } else if (type === 'client') {
                    this.$router.push({ path: `/${org[0].organisation_id}/dashboard` });
                } else {
                    this.$router.push({ path: '/dashboard' });
                }
            } else {
                // The action can handle redirects on failure, but we can set local state if needed.
                this.isError = true;
            }
        } catch (error) {
            console.error("Verification failed:", error);
            this.isError = true;
            // The action should ideally handle the redirect to login on catastrophic failure
        }
    },
    methods: {
        // Map the new action from your auth store
        ...mapActions('auth', ['verifyAuthentication', 'logout']),
    },

}
</script>